<div style="flex-direction: row;align-items: center;justify-content: center;flex:1;align-self: center;">




  <mat-card style="margin-top: 25px;margin-left: 2%;margin-right: 2%;">
    <span style="font-size: 20px; font-weight: bold;">{{"Asset Definition Setup" | translate | async}}</span>

    <div class="search-options"
      style="min-width: 150px;width: 100%;display: flex;justify-content: space-between;flex-wrap: wrap;padding: 0 2%;">

      <mat-form-field style="width: 400px">
        <mat-select [placeholder]="'Select Asset Type' | translate | async" [(ngModel)]="selectTypeId" name="GETType" (selectionChange)="ChangeType()">
          <mat-option *ngFor="let type of GETTypeList" [value]="type.Id">{{type.Name}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="header-form-full-width" style="width: 24%;">
        <input [(ngModel)]="selectedDispalyImpType_" type="text" [placeholder]="'Input Asset Definition' | translate | async" matInput>
      </mat-form-field>
      <mat-form-field class="header-form-full-width">
        <input [(ngModel)]="inputModelName" type="text" [placeholder]="'Input Model #' | translate | async" matInput>
      </mat-form-field>
    </div>
    <div class="search-options"
      style="min-width: 150px;width: 100%;display: flex;justify-content: space-between;flex-wrap: wrap;padding: 0 2%;">
      <div style="display: flex;flex-direction: row;justify-content: flex-end;align-self: flex-end;">
        <button style="margin-left: 20px;" mat-raised-button (click)="ResetAll()" color="warn"><span
            class="button__text">{{'Reset'| translate | async}}</span></button>
        <button style="margin-left: 20px;" mat-raised-button (click)="SeachResult()" color="warn"><span
            class="button__text">{{'Search'| translate | async}}</span></button>
        <button style="margin-left: 20px;" [disabled]="IsAddButton" mat-raised-button color="warn"
          (click)="AddImplementModel()"><span class="button__text">{{'Add New'| translate | async}}</span></button>
        </div>
    </div>
    <div *ngIf="!isSearchedResultnull">
      <table class="table table--full-width table--striped" style="margin-top: 9px;">

        <thead>
          <tr>
            <th>{{"Asset/System Type" | translate | async}}</th>
            <th>{{"Asset Definition" | translate | async}}</th> 
            <th>{{"Model #" | translate | async}}</th> 
            <th>{{"PDF Formats to be used" | translate | async}}</th> 
           
          </tr>
        </thead>
        <tbody>
          <ng-container *ngIf="resultList!=null">

            <tr *ngFor="let res of resultList;  let i = index" style="cursor: pointer;">
              <td> {{res.GETTypeName}}</td>
              <td>
                <!--- editable Assset defianatiom-->
                <div class="text-block">

                  <ng-container *ngIf="selectedRow === i">
                    <span class="text-block__important">
                      <span><input class="input-container__input" #dataInput id="Id_{{res.ImplementTypeId}}"
                          class="inputBtnAsset" [value]="res.ImpTypeName" [(ngModel)]="res.ImpTypeName"
                          focusOnShow /></span>

                      <i class="material-icons save-button__icon editcancel" (click)="saveAssetDefination(res)">check</i>
                      <i class="material-icons cancel-button__icon editcancel"
                        (click)="CancelAssetDefination(res)">close</i>
                    </span>
                  </ng-container>
                  <ng-container *ngIf="!(selectedRow === i)">
                    <span *ngIf="editableAssetDefination">{{res.ImpTypeName}}</span>
                    <span *ngIf="editableAssetDefination"><i class="material-icons text-container__edit"
                        style="cursor: pointer;" (click)="editAssetDefination(res,i)">edit</i></span>
                  </ng-container>
                </div>
                <!--- editable Assset defianatiom-->




              </td>
              <td>
  <!--- editable model-->
  <div class="text-block">

    <ng-container *ngIf="selectedAssetRow === i">
      <span class="text-block__important">
        <span><input class="input-container__input" #dataInput id="Ids_{{res.ImplementTypeId}}"
            class="inputBtnAsset" [value]="res.ModelName" [(ngModel)]="res.ModelName"
            focusOnShow /></span>

        <i class="material-icons save-button__icon editcancel" (click)="saveModel(res)">check</i>
        <i class="material-icons cancel-button__icon editcancel"
          (click)="CancelModel(res)">close</i>
      </span>
    </ng-container>
    <ng-container *ngIf="!(selectedAssetRow === i)">
      <span>{{res.ModelName}}</span>
      <span><i class="material-icons text-container__edit"
          style="cursor: pointer;" (click)="editModel(res,i)">edit</i></span>
    </ng-container>
  </div>
  <!--- editable Assset defianatiom-->



              </td>
              <td>

                <mat-form-field class="col-lg-4">
                    <mat-select name="status" placeholder="Select Style"
                        [(ngModel)]="res.ReportId" (selectionChange)="StatusChange(res.ImplementTypeId, res.ReportId)">
                        <mat-option *ngFor="let status of ReportStyles" [value]="status.ReportId">
                            {{ status.ReportName }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
              </td>
            </tr>
          </ng-container>


        </tbody>

      </table>


    </div>
    <!-- <div *ngIf="isSearchedResultnull">
      <span style="font-size: 13px;">No Data Found</span>

    </div> -->

  </mat-card>


  <div style="width: 100%;">





  </div>



</div>